export default __webpack_public_path__ + "b28c56d92bb6f1042f50dd3190c9f5ff.png";